import type { ComponentProps } from "react";
import {
  type FieldValues,
  FormProvider,
  type FormProviderProps,
  type SubmitErrorHandler,
  type SubmitHandler,
} from "react-hook-form";

export type FormProps<
  TFieldValues extends FieldValues,
  TContext = unknown,
  TTransformedValues = TFieldValues,
> = FormProviderProps<TFieldValues, TContext, TTransformedValues> &
  Pick<ComponentProps<"form">, "style"> & {
    onSubmitValid: SubmitHandler<TTransformedValues>;
    onSubmitInvalid?: SubmitErrorHandler<TFieldValues>;
  };

export const Form = <
  TFieldValues extends FieldValues,
  TContext = unknown,
  TTransformedValues extends FieldValues | undefined = undefined,
>({
  children,
  onSubmitValid,
  onSubmitInvalid,
  style,
  ...props
}: FormProps<TFieldValues, TContext, TTransformedValues>) => {
  return (
    <FormProvider {...props}>
      <form
        onSubmit={props.handleSubmit(onSubmitValid, onSubmitInvalid)}
        style={style}
      >
        {children}
      </form>
    </FormProvider>
  );
};
